import React, { useState, useEffect } from "react";
import View from "./evaluationManagerForm.view";
import * as EvaluationServices from "../../../../services/EvaluationServices";
import { getIsEvaluatedSelector } from "../../../../store/selectors/authSelector";
import { useSelector } from "react-redux";
import { useEvaluations } from "../hook/useEvaluations";
import { useTranslation } from "react-i18next";

const EvaluationManagerFormContainer = ({ uuid }) => {
  const [data, setData] = useState(null);
  const isEvaluated = useSelector(getIsEvaluatedSelector);
  const { t, i18n } = useTranslation();

  const loadData = () => {
    EvaluationServices.getUserEvaluation(uuid).then((result) => {
      if (result?.professionalSkill && result.professionalSkill.length > 0) {
        let count = 1;
        for (const skill of result.professionalSkill) {
          const languages = Object.keys(skill.translations);
          for (const lng of languages) {
            i18n.addResourceBundle(
              lng,
              `skill`,
              { [`skill_${count}`]: skill.translations[lng] },
              true,
              true
            );
          }
          count++;
        }
      }
      setData(result);
    });
  };

  const { completeEval, saveUnitObjective } = useEvaluations(loadData);

  useEffect(() => {
    loadData();
  }, [isEvaluated]);

  const handlerShowAutoEval = async () => {
    await completeEval(data);
  };

  const handlerSaveObjective = async (values) => {
    await saveUnitObjective(values, data, true);
  };

  return (
    <>
      {data && data !== "NO" && (
        <View
          data={data}
          finishEval={handlerShowAutoEval}
          onSaveObjective={handlerSaveObjective}
          user={false}
        />
      )}
    </>
  );
};

export default EvaluationManagerFormContainer;
